// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"620":"f60eccff","787":"e90634d3"}[chunkId] + ".chunk.js";
};